import { createFileRoute, redirect, Outlet } from '@tanstack/react-router';

// Protected layout for the whole super-admin area: ONE platform-admin guard for
// the entire `/super-admin/*` subtree, so any route added under it is gated by
// construction. Child routes keep their own `beforeLoad` guard as
// defense-in-depth (mirrors the guarded `/api/config` backend router).
function SuperAdminLayout() {
  return <Outlet />;
}

export const Route = createFileRoute('/_auth/_side-layout/super-admin')({
  component: SuperAdminLayout,
  beforeLoad: async ({ context }) => {
    if (context.platformRole !== 'admin') {
      throw redirect({ to: '/' });
    }
  },
});
